import {
  GS_AFFILIATE_ID,
  PROMPTING_U_SKUS,
  SOC_SKUS,
  STREAM_MARKETING_SKUS,
  STREAM_VA_SKUS,
} from 'src/marketing/plans/constants'
import plansInfo from 'src/marketing/plans/plansInfo'
import { SubscriptionType } from 'src/user/fragments'
import { useAccount } from '.'

const useSubscriptions = () => {
  const {
    stripeSubscription: currentSubscription,
    subscriptions: allSubscriptions,
    plan: currentPlan,
    type,
  } = useAccount()

  const currenPlanStripeId = currentPlan.stripeId
  const newPlanStripeId = currentSubscription?.metadata?.planOnCancel
  const newPlan = plansInfo.plans.find(
    plan => plan.stripeId === newPlanStripeId,
  )
  const isInGreenerStillGracePeriod =
    type === 'GSA' &&
    !(
      allSubscriptions &&
      allSubscriptions.find(
        (sub: SubscriptionType) => sub.sku === GS_AFFILIATE_ID,
      )
    )

  const hasPromptingUSubscription =
    allSubscriptions &&
    allSubscriptions.find((sub: SubscriptionType) =>
      PROMPTING_U_SKUS.includes(sub.sku),
    )

  const hasStreamMarketingSubscription =
    allSubscriptions &&
    allSubscriptions.find((sub: SubscriptionType) =>
      STREAM_MARKETING_SKUS.includes(sub.sku),
    )

  const hasStreamVASubscription =
    allSubscriptions &&
    allSubscriptions.find((sub: SubscriptionType) =>
      STREAM_VA_SKUS.includes(sub.sku),
    )

  const hasSocSubscription =
    allSubscriptions &&
    allSubscriptions.find((sub: SubscriptionType) => SOC_SKUS.includes(sub.sku))

  return {
    allSubscriptions,
    currentSubscription,
    currentPlan,
    currenPlanStripeId,
    newPlan,
    newPlanStripeId,
    isInGreenerStillGracePeriod,
    hasPromptingUSubscription,
    hasStreamMarketingSubscription,
    hasStreamVASubscription,
    hasSocSubscription,
  }
}

export default useSubscriptions
